import { render, staticRenderFns } from "./OrgFeeProjection.vue?vue&type=template&id=24145da6&scoped=true&"
import script from "./OrgFeeProjection.vue?vue&type=script&lang=js&"
export * from "./OrgFeeProjection.vue?vue&type=script&lang=js&"
import style0 from "./OrgFeeProjection.vue?vue&type=style&index=0&id=24145da6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24145da6",
  null
  
)

export default component.exports